export default __webpack_public_path__ + "static/media/d11.be7e9bf0.jpg";